import React from "react";
import NewPasswordForm from "../form/NewPasswordForm";
import SpravaUctuApi from "../../api/gen/core/SpravaUctuApi";
import { Button, Col, Row } from "reactstrap";
import CardTitle from "../layout/CardTitle";
import * as PropTypes from "prop-types";
import { SubmissionError } from "redux-form";
import * as TypDokladu from "mc/lib/api/gen/subjekty/v1/TypDokladu";
import DokladForm from "../form/DokladForm";
import RegistrationContent from "../registration/RegistrationContent";
import { formatAdresa } from "../registration/commons";
import {i18n, i18nCustom} from "../../i18n/i18n";
import { withLang } from "../../i18n/withLang";
import { EospPageContent } from "../layout/EospPageContent";import {brandTitle} from "../../i18n/Message";
import {HorizontalLoader, modal, ModalActions} from "@mc/mc-legacy";
import {connect} from "react-redux";
import * as CustomModalActions from "../../actions/CustomModalActions";
import {showInfo} from "../../actions/CustomModalActions";
const PAGE_STATE_DOKLAD = "PAGE_STATE_DOKLAD";
const PAGE_STATE_SET_PASSWORD = "PAGE_STATE_SET_PASSWORD";
const PAGE_STATE_DONE = "PAGE_STATE_DONE";
/**
 * První nastavení hesla, nejfříve je vyžadován doklad a poté je umožněno prvotní nastavení hesla.
 */

class SetFirstPassword extends React.Component<any, any> {
  constructor(props) {
    super(props);
    const vyzadovatDoklad = (window as any).appConfig.vyzadovatDoklad;
    this.state = {
      vyzadovatDoklad,
      // pageState: PAGE_STATE_DOKLAD,
      pageState: vyzadovatDoklad ? PAGE_STATE_DOKLAD : PAGE_STATE_SET_PASSWORD,
      doklad: null,
      typDokladu: null,
    };
  }

  static propTypes = {
    code: PropTypes.string.isRequired,
    // reset code
    onLoginRedirect: PropTypes.func.isRequired, // akce po nastavení hesla
  };
  novaRegistraceJmenoHesloSubmit = (code, newPassword) => {
    const { doklad, typDokladu } = this.state;
    const novaRegistraceJmenoHeslo = {
      resetCode: code,
      checkOperation: false,
      newPassword,
      doklad,
      typDokladu,
    };

    return SpravaUctuApi.novaRegistraceJmenoHeslo(novaRegistraceJmenoHeslo).then(
          this.props.dispatch(
              CustomModalActions.showInfo(
                  "",
                  <div style={{minWidth: 320}}>
                      <div className={"pb-2"}>{i18n(this.props.lang, "ProcessLoadingPage")}</div>
                      <HorizontalLoader/>
                  </div>,
                  null,
                  false,
                  false,
                  {
                      noHeader: true,
                  }
              )
          )

      ).then((userData) => {
          this.props.dispatch(modal.ModalActions.hide());
          return userData;
      }).catch((error) => {
          this.props.dispatch(modal.ModalActions.hide());
          throw new SubmissionError(error.errors);
      })


  };
  changeResettedPasswordSubmitSuccess = (userData) => {
    this.setState({
      pageState: PAGE_STATE_DONE,
      userData,
    });
  };
  renderStateDoklad = () => {
    const { code, lang } = this.props;
    return (
      <div>
        <RegistrationContent icon={"government-buildings"}>
          {i18n(this.props.lang, "SetFirstPassword_DokladFill")}
        </RegistrationContent>
        <DokladForm
          key={lang} initialValues={{
            typDokladu: TypDokladu.ID,
          }}
          onSubmit={(formData) => {
            const novaRegistraceJmenoHeslo = {
              resetCode: code,
              checkOperation: true,
              doklad: formData.idDoklad,
              typDokladu: formData.typDokladu,
            };

               return SpravaUctuApi.novaRegistraceJmenoHeslo(novaRegistraceJmenoHeslo).then(
                   this.props.dispatch(
                       CustomModalActions.showInfo(
                           "",
                           <div style={{minWidth: 320}}>
                               <div className={"pb-2"}>{i18n(this.props.lang, "ProcessLoadingPage")}</div>
                               <HorizontalLoader/>
                           </div>,
                           null,
                           false,
                           false,
                           {
                               noHeader: true,
                           }
                       )
                   )

               ).then((userData) => {
                   this.props.dispatch(modal.ModalActions.hide());
                   return {
                   userData,
                   formData,
                 };
               }).catch((error) => {
                   console.log(error.errors.error);
                   this.props.dispatch(modal.ModalActions.hide());
                   throw new SubmissionError(error.errors);
               })

          }}

          onSubmitSuccess={({ userData, formData }) => {
            this.setState({
              pageState: PAGE_STATE_SET_PASSWORD,
              doklad: formData.idDoklad,
              typDokladu: formData.typDokladu,
              userData,
            });
          }}
        />
      </div>
    );
  };
  renderStateSetPassword = () => {
    const { code } = this.props;
    const { vyzadovatDoklad, userData, typDokladu, doklad } = this.state;
    return (
      <div>
        {vyzadovatDoklad && (
          <RegistrationContent icon={"government-buildings"}>
            <Row>
              <Col>
                <p className={"mb-0 pl-3"}>
                  {userData.nazev}
                  <br />
                  {userData.adresa && userData.adresa.popis && <span>{formatAdresa(userData)}<br/></span>}
                  {i18n(this.props.lang, `TypDokladu_${typDokladu}`)}: {doklad}
                </p>
              </Col>
            </Row>
          </RegistrationContent>
        )}
        <NewPasswordForm
            key={this.props.lang}
          showAgreementForm={true}
          onSubmit={({ newPassword, newPassword_repeat }) => {
            // Async validace - chceme až na tlačítko submit, proto je zde
            if (newPassword !== newPassword_repeat) {
              throw new SubmissionError({
                _error: i18n(this.props.lang, "Form_HeslaNeshoduji"),
              });
            }

            return this.novaRegistraceJmenoHesloSubmit(code, newPassword);

          }}
          onSubmitSuccess={this.changeResettedPasswordSubmitSuccess}
        />
      </div>
    );
  };
  renderStateDone = () => {
    const { onLoginRedirect } = this.props;
    const { userData } = this.state;
    return (
      <div>
        <p>{i18n(this.props.lang, "SetFirstPassword_HesloNastaveno")}</p>
        <Button color={"primary"} onClick={() => onLoginRedirect(userData.loginToken)}>
          {i18n(this.props.lang, "button_Pokracovat")}
        </Button>
      </div>
    );
  };

  render() {
    const { code } = this.props;
    const { pageState } = this.state;

    if (!code) {
      return <div />;
    }

    let content;
    let showPageTitle = true;

    switch (pageState) {
      case PAGE_STATE_DOKLAD:
        content = this.renderStateDoklad();
        break;

      case PAGE_STATE_SET_PASSWORD:
        content = this.renderStateSetPassword();
        break;

      case PAGE_STATE_DONE:
        content = this.renderStateDone();
        break;
    }
        const title = brandTitle(this.props.lang);
        const prihlaseniRegistraceUrad = i18nCustom(this.props.lang, "prihlaseni.registrace.urad", false)

        return <EospPageContent>
            <CardTitle title={showPageTitle ? title : ""}>
                {prihlaseniRegistraceUrad && <h4 className={"font-weight-bold mb-4 sub-title"}>
                    {prihlaseniRegistraceUrad}
                </h4>}
            </CardTitle>
            {content}
        </EospPageContent>
    }
}

export default withLang(connect()(SetFirstPassword));
